import { useEffect } from 'react';
import { trackPageView } from 'base/utils/tracker';
import { useCheckIn } from 'mod/checkIn/useCheckIn';
import { CheckInContext, ICheckInContext } from 'mod/checkIn/useCheckInContext';
import { Interactive } from '@pro/420CheckIn/Interactive';
import { ShareResult } from '@pro/420CheckIn/Interactive/ShareResult';
import { Rules } from '@pro/420CheckIn/Rules';
import { useTrans } from 'base/utils/i18n';
import DefaultLoading from '@base/common/DefaultLoading';
import ErrorDisplay from '@base/lib/ErrorDisplay';

const Page: Globals.NextPage = () => {
    const ins = useCheckIn();
    const { data, active } = ins;
    const { t } = useTrans();

    useEffect(() => {
        trackPageView();
    }, []);

    if (!data) {
        return <DefaultLoading type="page"/>;
    }

    if (!active || !data.shareBoom) {
        return <ErrorDisplay errorTip={t('web_common_page_not_found')}/>;
    }

    return (
        <>
            <CheckInContext.Provider value={ins as ICheckInContext}>
                <Interactive/>
                <ShareResult/>
            </CheckInContext.Provider>

            <Rules/>
        </>
    )
};

Page.pageConf = {
    pageCode: '420CheckIn',
};

export default Page;
